import { Avatar, Box, Card, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useAppSelector } from "../assets/hooks";
import { setWordCase } from "../assets/library";
import ChatContainer from "../pages/chats/chatContainer";
import { Chat, Participant } from "../types/types";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface BakedData {
  dp: string;
  name: string;
  lastMessage?: LastMessage;
  unseenMessages: number;
  chatType: "1-1" | "group";
  activeParticipants: Participant[];
  role:string;
}
interface LastMessage {
  sender: "current" | "others";
  status: "seen" | "unseen";
  message: string;
}

const AdvisorChatComponent = (props: { data: Chat }) => {
  const [open1, setOpen1] = useState(false);
  const profileInfo = useAppSelector((state) => state.profileInfo);
  const profile = profileInfo?.data;

  const bakeLastMessage = (rawdata: Chat, currentUser: Participant) => {
    let bakedData: LastMessage = {
      sender:
        rawdata.lastMessage?.sender === currentUser._id ? "current" : "others",
      message: rawdata.lastMessage?.content ? rawdata.lastMessage?.content : "",
      status: "seen",
    };
    if (bakedData.sender === "current") {
      bakedData.status =
        rawdata.unSeenMessages.findIndex(
          (item) => item.message._id === rawdata.lastMessage?._id
        ) === -1
          ? "seen"
          : "unseen";
    } else {
      let index = rawdata.unSeenMessages.findIndex(
        (item) => item.message._id === rawdata.lastMessage?._id
      );
      bakedData.status =
        index === -1
          ? "seen"
          : rawdata.unSeenMessages[index].seen.findIndex(
              (item) => item === currentUser._id
            ) === -1
          ? "unseen"
          : "seen";
    }
    return bakedData;
  };

  const bakeActivity = (rawdata: Chat, currentUser: Participant) => {
    let inchat = rawdata.participants.filter(
      (participant) =>
        participant.activity === "inchat" && participant._id !== currentUser._id
    );
    let online = rawdata.participants.filter(
      (participant) =>
        participant.activity === "online" && participant._id !== currentUser._id
    );
    let typing = rawdata.participants.filter(
      (participant) =>
        participant.activity === "typing" && participant._id !== currentUser._id
    );
    return [...typing, ...inchat, ...online];
  };

  const bakedata = (rawdata: Chat, profile: any): BakedData => {
    let bakedData: BakedData = {
      dp: "",
      name: "",
      unseenMessages: 0,
      activeParticipants: [],
      chatType: "1-1",
      lastMessage: undefined,
      role:""
    };

    let currentUser = rawdata.participants.find(
      (participant) => participant._id === profile._id
    );

    let otherUsers = rawdata.participants.filter(
      (participant) => participant._id !== profile._id
    );

    if (rawdata.participants.length <= 2) {
      bakedData.name = otherUsers?.length > 0 
      ? (otherUsers?.[0]?.firstName 
          ? otherUsers?.[0]?.firstName 
          : "user") + 
        (otherUsers?.[0]?.lastName 
          ? " " + otherUsers?.[0]?.lastName 
          : "")
      : "Deleted User";
      bakedData.dp = otherUsers?.length > 0 ? otherUsers?.[0]?.displayPicSrc:"";
      bakedData.role = otherUsers?.length > 0 ? otherUsers?.[0]?.role :"";
    } else{
      bakedData.chatType = "group";
      bakedData.name = "Group Name";
    }
    bakedData.unseenMessages = rawdata?.unSeenMessages.filter((msg) => msg?.message?.sender?._id !== profile._id)
      .filter(
        (receivedMessage) =>
          !receivedMessage.seen.some((id) => id === profile._id)
      ).length;

    if (rawdata.lastMessage && currentUser) {
      bakedData.lastMessage = bakeLastMessage(rawdata, currentUser);
      bakedData.activeParticipants = bakeActivity(rawdata, currentUser);
    }

    return bakedData;
  };
  const bakedData = profile ? bakedata(props.data, profile) : null;


  const LastMessageContainer = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          gap:"8px",
          width: "100%",
        }}
      >
        {bakedData?.lastMessage?.sender === "current" ? (
          <>
            {bakedData?.lastMessage?.status === "seen" ? (
              <Box sx={{ display: "flex" }}>
                <DoneAllIcon sx={{ color: "#2196f3", fontSize: "1rem" }} />
              </Box>
            ) : (
              <Box sx={{ display: "flex" }}>
                <DoneAllIcon sx={{ color: "gray", fontSize: "1rem" }} />
              </Box>
            )}
          </>
        ) : null}
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight:
              bakedData?.lastMessage?.sender === "current"
                ? "300"
                : bakedData?.lastMessage?.status === "seen"
                ? "300"
                : "600",
            color:
              bakedData?.lastMessage?.sender === "current"
                ? "gray"
                : bakedData?.lastMessage?.status === "seen"
                ? "gray"
                : "#000",
          }}
        >
          {bakedData?.lastMessage?.message}
          <Typography fontWeight="400" color="#000" fontSize="0.8rem">
            {bakedData?.lastMessage?.message ? "" : "Tap to chat"}
          </Typography>
        </Typography>
      </div>
    );
  };

  return (
    <div>
      <Card
        sx={{ p: 2, border: " 1px solid #d7d7d7" }}
        onClick={() => setOpen1(true)}
      >
        <Grid container spacing={2}>
          <Grid item xs={2}>
          <Avatar
              src={bakedData?.dp}
              alt="logo"
              style={{ width: "3rem",height:"3rem", borderRadius: "50%" }}
            />
            {
                    bakedData?.chatType==="1-1"
                    ?
                        bakedData?.activeParticipants.length!==0 && bakedData?.activeParticipants[0].activity!=="offline"
                        ?
                        <FiberManualRecordIcon sx={{color:"green",fontSize:"1rem",position:"absolute",bottom:"0",right:"-7px"}}/>
                        :
                        null
                    :
                    null
                }
          </Grid>
          <Grid item xs={9}>
            <Typography fontWeight="600" gutterBottom>
              {setWordCase(bakedData?.name)}
            </Typography>
            {bakedData?.name === "Deleted User" ? <Box sx={{p:1}}></Box>: 
            <LastMessageContainer /> }
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{
              background: "#3B3F76",
              color:"#fff",
              borderRadius: "50%",
              width: "1rem",
              height: "1rem",
              fontSize: "11px",
              textAlign: "center",
            }}>{bakedData?.unseenMessages}</Typography>
          </Grid>
          <Grid item xs={12} sx={{position:"absolute",right:"10px",top:"-2rem",}}>
          <Typography fontWeight="500" sx={{background:"#fff",p:1,borderRadius:"10px",
            color:bakedData?.role === "counsellor" ? "#3B3F76": bakedData?.role === "processCoordinator" ? "#569228" :"#FEB853",fontSize:"14px"}}> 
            {bakedData?.role ? setWordCase(bakedData?.role) : bakedData?.role}
            </Typography>
          </Grid>
        </Grid>
      </Card>
      {open1 ? (
        <ChatContainer
          open={open1}
          setOpen={setOpen1}
          id={props?.data?._id}
          type="advisors"
        />
      ) : null}
    </div>
  );
};

export default AdvisorChatComponent;
